import React from "react"
import styled from "styled-components"

// Components
import Label from "../atoms/Label"
import Error from "../atoms/Error"
import Icon from "../../icons/Icon"

// Styles
import textStyles from "../../../styles/textStyles"
import colors from "../../../styles/colors"

interface IProps {
  label: string
  name: string
  reference: any
  placeholder?: string
  error?: string
  options: {
    value: string
    label: string
  }[]
}

const Dropdown: React.FC<IProps> = ({
  label,
  name,
  reference,
  options,
  error,
}) => {
  return (
    <Wrapper>
      <Label label={label} />
      <DropdownWrapper>
        <StyledDropdown name={name} defaultValue="" ref={reference}>
          <option value="" disabled>
            Select
          </option>
          {options.map((option, index) => (
            <option key={`${index}-${option.value}`} value={option.value}>
              {option.label}
            </option>
          ))}
        </StyledDropdown>
        <StyledIcon
          icon="chevron"
          direction="down"
          width={10}
          height={16}
          color={colors.whitePurple}
        />
      </DropdownWrapper>
      <Error error={error} />
    </Wrapper>
  )
}

export default Dropdown

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 16px;
`

const DropdownWrapper = styled.div`
  position: relative;
  width: 100%;
`

const StyledDropdown = styled.select`
  appearance: none;
  outline: 0;
  border-radius: 8px;
  cursor: pointer;
  width: 100%;
  padding: 12px 40px 12px 16px;
  ${textStyles.body};
  color: ${colors.blueGrey};
  border: 2px solid ${colors.whitePurple};
  margin: 0;

  ::placeholder {
    color: ${colors.whitePurple};
  }
`

const StyledIcon = styled(Icon)`
  position: absolute;
  right: 24px;
  top: 18px;
`
